import createTableStore from "ds/components/Table/store/useTableStore";

import {
  TEMPLATES_WORKBENCH_COLUMN_CONFIG,
  TEMPLATES_WORKBENCH_COLUMNS_STORAGE_KEY,
} from "./constants";

const useTemplatesTableStore = createTableStore({
  storageKey: TEMPLATES_WORKBENCH_COLUMNS_STORAGE_KEY,
  config: TEMPLATES_WORKBENCH_COLUMN_CONFIG,
});
export default useTemplatesTableStore;
